<template>
  <div>
    <center v-if="load">
      <b-spinner
        variant="primary"
        label="Spinning"
      />
    </center>
    <b-card
      v-else
      class="p-0 filter-card rounded-lg"
    >
      <b-form @submit.prevent="onSubmit">
        <validation-observer
          ref="customerForm"
          class="w-100"
        >
          <b-row>
            <b-col
              sm="6"
              md="4"
              class="mb-2"
            >
              <validation-provider
                #default="{ errors }"
                name="الاسم"
                vid="name"
                rules="required"
              >
                <b-form-group
                  label="الاسم *"
                  label-for="name"
                >
                  <b-input-group>
                    <b-form-input
                      v-model="customer.name"
                      placeholder="الاسم"
                    />
                  </b-input-group>
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              sm="6"
              md="4"
              class="mb-2"
            >
              <validation-provider
                #default="{ errors }"
                name="الرقم القومي"
                vid="national_id"
                rules="national_id"
              >
                <b-form-group
                  label="الرقم القومي "
                  label-for="national_id"
                >
                  <b-input-group>
                    <b-form-input
                      v-model="customer.national_id"
                      placeholder="الرقم القومي"
                      maxlength="14"
                    />
                  </b-input-group>
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              sm="6"
              md="4"
              class="mb-2"
            >
              <validation-provider
                #default="{ errors }"
                name=" (وجه أمامي) صورة الرقم القومي"
                vid="national_id_image"
              >
                <b-form-group
                  label="صورة الرقم القومي (وجه أمامي) "
                  label-for="national_id_image"
                >
                  <b-form-file
                    v-model="customer.national_id_image.image_1"
                    accept="image/*"
                    :state="Boolean(customer.national_id_image.image_1)"
                    placeholder="اختر صورة"
                    drop-placeholder="اسحب الصورة هنا"
                    browse-text="تصفح"
                    @change="onImageChange($event, 'image_1')"
                  />
                  <div
                    v-if="preview.image_1"
                    style="margin: 3px; display:inline-block;"
                  >
                    <img
                      :src="preview.image_1"
                      width="90"
                    >
                  </div>
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              sm="6"
              md="4"
              class="mb-2"
            >
              <validation-provider
                #default="{ errors }"
                name=" (وجه خلفي) صورة الرقم القومي"
                vid="national_id_image"
              >
                <b-form-group
                  label="صورة الرقم القومي (وجه خلفي) "
                  label-for="national_id_image"
                >
                  <b-form-file
                    v-model="customer.national_id_image.image_2"
                    accept="image/*"
                    :state="Boolean(customer.national_id_image.image_2)"
                    placeholder="اختر صورة"
                    drop-placeholder="اسحب الصورة هنا"
                    browse-text="تصفح"
                    @change="onImageChange($event, 'image_2')"
                  />
                  <div
                    v-if="preview.image_2"
                    style="margin: 3px; display:inline-block;"
                  >
                    <img
                      :src="preview.image_2"
                      width="90"
                    >
                  </div>
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              sm="6"
              md="4"
              class="mb-2"
            >
              <validation-provider
                #default="{ errors }"
                name="الهاتف"
                vid="phone"
                rules="phone"
              >
                <b-form-group
                  label="الهاتف *"
                  label-for="phone"
                >
                  <b-input-group>
                    <b-form-input
                      v-model="customer.phone"
                      placeholder="الهاتف"
                    />
                  </b-input-group>
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              sm="6"
              md="4"
              class="mb-2"
            >
              <validation-provider
                #default="{ errors }"
                name="الايميل"
                vid="email"
                :rules="customer.email && customer.email.trim() ? 'email' : ''"
              >
                <b-form-group
                  label="الايميل"
                  label-for="email"
                >
                  <b-input-group>
                    <b-form-input
                      v-model="customer.email"
                      placeholder="الايميل"
                    />
                  </b-input-group>
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              md="6"
              class="mb-2"
            >
              <validation-provider
                #default="{ errors }"
                name="عنوان المراسلات"
                vid="address"
              >
                <b-form-group
                  label="عنوان المراسلات"
                  label-for="address"
                >
                  <b-input-group>
                    <b-form-input
                      v-model="customer.address"
                      placeholder="العنوان"
                    />
                  </b-input-group>
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              sm="6"
              md="4"
              class="mb-2"
            >
              <validation-provider
                #default="{ errors }"
                name="الوظيفة"
                vid="position"
              >
                <b-form-group
                  label="الوظيفة *"
                  label-for="position"
                >
                  <b-input-group>
                    <b-form-input
                      v-model="customer.position"
                      placeholder="الوظيفة"
                    />
                  </b-input-group>
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              v-if="customer.id"
              cols="12"
              class="mb-2"
            >
              <small class="text-muted d-block">حساب الدفتر</small>
              <strong>{{ glAccountLabel || '—' }}</strong>
            </b-col>
            <b-col
              sm="6"
              md="4"
              class="mb-2"
            >
              <validation-provider
                name="جهة العمل"
                vid="authority_id"
              >
                <b-form-group
                  label="جهة العمل "
                  label-for="authority_id"
                >
                  <v-select
                    v-model="customer.authority_id"
                    :options="authoritiesList"
                    :reduce="val => val.id"
                    :get-option-label="option => option.authority_name"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
        <div class="d-flex justify-content-end">
          <b-button
            :disabled="saving"
            variant="primary"
            type="submit"
          >
            <b-spinner
              v-if="saving"
              small
              class="mr-1"
            />
            <span v-else>
              {{ customer.id ? 'تحديث' : 'حفظ' }}
            </span>
          </b-button>
          <b-button
            class="ml-1"
            @click="resetForm"
          >
            الغاء
          </b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BForm, BFormGroup, BFormInput, BInputGroup, BRow, BCol, BButton, BFormFile, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  required, email, phone, national_id,
} from '@validations'
import { glAccountText } from '@/utils/ledger'

export default {
  components: {
    BCard, BForm, BFormGroup, BFormInput, BInputGroup, BRow, BCol, BButton, vSelect, ValidationObserver, BSpinner, ValidationProvider, BFormFile,
  },
  // props: {
  //   customerId: {
  //     type: Number,
  //     required: false,
  //     default: null,
  //   },
  // },

  data() {
    return {
      saving: false,
      customer: {
        id: null,
        name: '',
        national_id: '',
        national_id_image: {
          image_1: null,
          image_2: null,
        },
        email: '',
        phone: '',
        address: '',
        position: '',
        authority_id: null,
      },
      preview: {
        image_1: null,
        image_2: null,
      },
      glAccountLabel: '',
    }
  },
  computed: {
    ...mapGetters({
      authoritiesList: 'authorities/authorities',
      load: 'customers/load',
    }),
    customerId() {
      return this.$route.params.id ? this.$route.params.id : null
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.$store.dispatch('authorities/list')
      if (this.customerId) {
        // Fetch customer info to edit
        this.$store.dispatch('customers/show', { id: this.customerId })
          .then(res => {
            const d = res.data
            this.customer = {
              id: d.id,
              name: d.name,
              national_id: d.national_id,
              national_id_image: {
                image_1: null,
                image_2: null,
              },
              email: d.email,
              phone: d.phone,
              address: d.address,
              position: d.position,
              authority_id: d.authority_id,
            }
            this.glAccountLabel = glAccountText(d) || '—'
          })
      }
    },
    resetForm() {
      this.customer = {
        id: null,
        name: '',
        national_id: '',
        national_id_image: {
          image_1: null,
          image_2: null,
        },
        email: '',
        phone: '',
        address: '',
        position: '',
        authority_id: null,
      }
      this.glAccountLabel = ''
      this.$refs.customerForm && this.$refs.customerForm.reset()
      this.$emit('cancel')
    },
    onSubmit() {
      this.$refs.customerForm.validate().then(success => {
        if (!success) return

        this.saving = true
        const formData = new FormData()
        const skipKeys = ['gl_account', 'gl_account_id']
        Object.keys(this.customer).forEach(key => {
          if (skipKeys.includes(key)) return
          if (key === 'national_id_image') {
            if (this.customer.national_id_image.image_1) formData.append('national_id_image[image_1]', this.customer.national_id_image.image_1)
            if (this.customer.national_id_image.image_2) formData.append('national_id_image[image_2]', this.customer.national_id_image.image_2)
          } else {
            const value = this.customer[key] === null ? '' : this.customer[key]
            formData.append(key, value)
          }
        })

        const request = this.customer.id
          ? this.$store.dispatch('customers/update', { id: this.customer.id, query: formData })
          : this.$store.dispatch('customers/store', { query: formData })

        request
          .then(res => {
            const saved = res && res.data && !Array.isArray(res.data) ? res.data : res
            const accountText = glAccountText(saved) || '—'
            this.glAccountLabel = accountText
            this.$swal({
              icon: 'success',
              title: `<h4>${(res && res.message) || ''}</h4>`,
              html: `<div>حساب الدفتر: ${this.escapeHtml(accountText)}</div>`,
              showConfirmButton: true,
              confirmButtonColor: '#06284D',
              allowOutsideClick: true,
            })
            this.resetForm()
            this.$router.push({ name: 'customers' })
          })
          .catch(error => {
            if (error.response && error.response.data && error.response.data.errors) {
              this.$refs.customerForm.setErrors(error.response.data.errors)
            } else if (error.response) {
              this.$swal({
                icon: 'error',
                title: `<h4>${error.response.data.message}</h4>`,
                showConfirmButton: true,
                confirmButtonColor: '#06284D',
                allowOutsideClick: true,
              })
            }
          })
          .finally(() => {
            this.saving = false
          })
      })
    },
    escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
    },
    onImageChange(event, which) {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = e => {
          this.preview[which] = e.target.result
        }
        reader.readAsDataURL(file)
        this.$set(this.customer.national_id_image, which, file)
      } else {
        this.preview[which] = null
        this.$set(this.customer.national_id_image, which, null)
      }
    },
  },
}
</script>
